import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyRouteMeta } from "../seo/head";

// Mantiene title/description/canonical/OG al día cuando cambia la ruta en el cliente.
export default function RouteHead() {
  const { pathname } = useLocation();
  useEffect(() => {
    applyRouteMeta(document, pathname);
  }, [pathname]);
  return null;
}
